/** @jsx h */
import { h } from 'preact'
import IconDown from '../../../../assets/images/svgs/icon-chevron-down.svg'
import Details from '../Details'

const DescriptionSection = ({ iconSvg, title, description, analyticsContext }) =>
  <Details analyticsName='descriptionSection' analyticsContext={analyticsContext}>
    <summary class='Summary Summary--withIcon'>
      <div dangerouslySetInnerHTML={{ __html: iconSvg.replaceAll('44px', '72px') }} />
      <h3>{title}</h3>
      <IconDown class='chevron' aria-hidden />
    </summary>
    <div class='Details-description'>
      {description}
    </div>
  </Details>

export default DescriptionSection
